module.exports = __webpack_public_path__ + "static/topcon-35e3e7302fcf282a95afc08bd54b9489.png";